$(document).ready(function(){
    if ($('#get-started-nav').length >0) {
        if (page_info.start_url !== undefined){
            $('#get-started-nav').attr("href", page_info.start_url);
        }

    }
});
